import * as React from 'react';
import S from './VideoTestimonialCard.styles';
import { getSrcs } from '@helpers/image';
import { SystemIcon, getSvgFromSystem } from '@helpers/systemIcons';
import VideoEmbed from '@stories/Components/Misc/VideoEmbed/VideoEmbed';
const VideoTestimonialCard = ({ title, image, video, mobileImage, testimonial, supportingText, theme = 'yellow', disableQuoteIcon, }) => {
    const srcs = image ? getSrcs(image, 302, 218, 4) : [];
    const mobileSrcs = image ? getSrcs(mobileImage ?? image, 222, 175, 4) : [];
    const [isPlaying, setIsPlaying] = React.useState(false);
    return (React.createElement(S.Container, { "data-widget-theme": theme, "data-is-playing": isPlaying },
        React.createElement(S.Inner, null,
            React.createElement(S.MediaContainer, null,
                React.createElement(S.MediaHolder, null,
                    video && !image &&
                        React.createElement("div", { className: 'hide-no-js' },
                            React.createElement(VideoEmbed, { ...video, setIsPlaying: (playing) => setIsPlaying(playing) })),
                    image && !video && (React.createElement(React.Fragment, null,
                        React.createElement(S.ImageDesktop, { alt: image?.altText ?? '', loading: "lazy", role: image?.altText ? undefined : 'presentation', src: srcs[0].split(' ')[0], srcSet: srcs.join(',') }),
                        React.createElement(S.ImageMobile, { alt: mobileImage?.altText ?? '', loading: "lazy", role: mobileImage?.altText ? undefined : 'presentation', src: mobileSrcs[0].split(' ')[0], srcSet: mobileSrcs.join(',') })))),
                !disableQuoteIcon && React.createElement(S.QuoteIconImageArea, null, getSvgFromSystem(SystemIcon.Quote))),
            React.createElement(S.ContentArea, null,
                React.createElement(S.ContentInner, null,
                    React.createElement(S.Title, null, title),
                    testimonial && React.createElement(S.Intro, { dangerouslySetInnerHTML: { __html: testimonial } }),
                    supportingText && React.createElement(S.SupportText, null, supportingText))))));
};
export default VideoTestimonialCard;
